export default function obtradeRowSelection(
	groupIndex: number,
	index: number,
	tableData: Array<any>,
	isAllSelected: boolean,
	key?: string,
	value?: any
) {
	function handleRwWithKeyVal(row: any, selectFlag: boolean) {
		
		if (key) {
			// invert the status
			if (row[key] === value) {
				row.isSelected = !selectFlag;
			}
		} else {
			row.isSelected = !selectFlag;
		}
		return row;
	}
	// copy the data
	let data = [...tableData],
		allSelected: boolean = isAllSelected,
		count: number = 0,
		condCount: number = 0,
		rwCount: number = 0;

	// if checkbox of any row is selected
	if (groupIndex >= 0 && index >= 0) {
		const group = [...data[groupIndex]];
		// get the row
		const row = { ...group[index] };
		row.isSelected = !tableData[groupIndex][index].isSelected;

		// put the updated row back in data
		group[index] = row;
		data[groupIndex] = group;
	}
	// if all clicked on all selected checkbox
	else if (groupIndex === -1 && index === -1) {
		// loop over the data
		// If isAllDataSelected is true, then set every row to false
		// else if isAllDataSelected is false, then set every row to true
		data = data.map(group => group.map((row: any) => handleRwWithKeyVal(row, isAllSelected)));

		// count = !isAllSelected ? data[0].length : 0;

		allSelected = !isAllSelected;
	}

	data.forEach(group =>
		group.forEach((row: any) => {
			rwCount += 1; //each row in data table
			if (row.isSelected === true) {
				count += 1; //selected row count
			}
			if (key && row[key] === value) {
				condCount += 1; //conditional verified row count
			}
		})
	);
	//if conditinal count matches with selected count then set all selected to true
	count === condCount ? (allSelected = true) : (allSelected = false);
	if (!key) {
		// in the absence of condition check with total row counts
		rwCount === count ? (allSelected = true) : (allSelected = false);
	}
	return {
		data: data,
		count: count,
		allSelected: count > 0 ? allSelected : allSelected
	};
}
